import { Button } from '@cian/ui-kit';
import { ModalWindow } from '@cian/ui-kit/modal';
import * as React from 'react';

import * as styles from './styles.css';
const successIcon = require('./assets/success.svg') as string;

export interface ISuccessStateProps {
  open: boolean;
  onClose(): void;
}

export const Success = ({ open, onClose }: ISuccessStateProps) => {
  return (
    <ModalWindow
      content={
        <div className={styles['container']}>
          <img src={successIcon} />
          <h1 className={styles['title']}>Анкета отправлена</h1>
          <div className={styles['text']}>Вам придёт СМС с ответом собственника</div>
          <Button onClick={onClose}>Хорошо</Button>
        </div>
      }
      onClose={onClose}
      open={open}
    />
  );
};
